import script from "./HoldingsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./HoldingsTable.vue?vue&type=script&setup=true&lang=js"

import "./HoldingsTable.vue?vue&type=style&index=0&id=943c45aa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-943c45aa"]])

export default __exports__